import type {
  RelatedDocumentsDto,
  TableCacheKeyDto,
} from '@asset-metrix/portal-gateway-client-js';

import { getRowBusinessId } from '../table/sidebar/getRowBusinessId';
import type { TableSidebarRowData } from '../table/sidebar/useTableSidebarProperties';

export type PageSidebarScope = 'page' | 'fullscreen';

export type PageSidebarActiveContent = {
  widgetId: string;
  data: TableSidebarRowData;
  sideBarType: TableCacheKeyDto['dataSourceType'];
  relatedDocumentsConfig?: RelatedDocumentsDto;
  showWorkflowFiles: boolean;
  fileDownloadColumnKeys: string[];
};

/** Document currently previewed inside a sidebar's document panel. */
export type PageSidebarPreviewedDocument = {
  id: string;
  label: string;
};

export type PageSidebarSessionState = {
  active: PageSidebarActiveContent | null;
  opened: boolean;
  previewedDocument: PageSidebarPreviewedDocument | null;
};

export const AI_CHAT_FEATURE_FLAG = 'aiChat';

function getTableSidebarRowIdentityKey(data: TableSidebarRowData): string {
  const businessId = getRowBusinessId(data.data);

  return businessId != null ? String(businessId) : data.rowId;
}

export function getPageSidebarActiveKey(
  active: PageSidebarActiveContent
): string {
  return `${active.widgetId}:${getTableSidebarRowIdentityKey(active.data)}`;
}
